import { GridRowSelectionModel } from '@mui/x-data-grid';

export interface RoomPostingTransactionDetails {
  folioUuid: string;
  folioStatus: string;
  roomStatus?: string;
}
export interface RoomPostingEntriesList {
  id: string;
  caption: string;
  e_type: number;
  is_required: number;
}

export interface RoomPostingLedgerData {
  _id: string;
  transaction_id: string;
  posting_date: string;
  item: string;
  charges: string;
  collection: string;
  cl_collection: string;
  adjustments: string;
  gross_amount: string;
  vat: string;
  discount: string;
  local_tax: string;
  service_charge: string;
  service_charge_rate: string;
  net: string;
  outlet: string;
  line_remarks: string;
  entry_remarks: string;
  discount_remarks: string;
  category_type: string;
  cashier: string;
  dr_cr_adj: string;
  sub_group: number | string;
  voided: string;
  is_cs_slip: string;
  cs_slip_no: string;
  print_id: string;
  booking_id: string;
  is_fo?: number;
  invoice_no?: string;
}

export interface RoomPostingBalance {
  defaultFolio: string;
  folioA: string;
  folioB: string;
  folioC: string;
  folioD: string;
}

export interface RoomPostingSummary {
  totalCharges: string;
  totalCollection: string;
  totalAdjustment: string;
  totalPayables: string;
}

export interface RoomPostingData {
  folioUuid: string;
  folioNo: string;
  rateTotalAmount: number;
  dateCheckin: string;
  dateCheckout: string;
  totalBillAmount: string;
  profileID: string;
  guestID: string | number;
  guestName: string;
  isClHotel: number;
  creditLimit: number;
  totalPax: number;
  roomNo: string;
  rowCount: number;
  lockByUserShortName: string;
  netLock: number;
  summary: RoomPostingSummary;
  balance: RoomPostingBalance;
  ledgerResult: RoomPostingLedgerData[];
  bookingStatus?: string;
  rateAmount: number;
}

export interface RoomPostingLedgerList {
  status: number;
  data: RoomPostingData;
  message: string;
  buildVersion: string;
}

export interface RoomPostingCLPaymentBreakdownEntry {
  ledgerTransactionID: string | number;
  currentCollection: string | number;
  originalCollection: string | number;
}
export interface RoomPostingTransactionEntry {
  properties: Array<{
    property: {
      propertyID: string;
      entries: Array<{
        entry: {
          transaction_identifier: string;
          cutoff_date: string;
          quantity: number;
          gross_amount: number;
          mapping_type: number;
          module_id: number;
          transaction_type: number;
          dr_cr_adj: number;
          item: string;
          discount: number;
          discount_type: number;
          sub_group: number;
          category_type: number;
          line_remarks?: string;
          discount_remarks?: string;
          payment_details: {
            or_no?: string;
            issuing_bank?: string;
            check_date?: string;
            check_number?: string;
            gift_certificate_number?: string;
            card_network?: string;
            cc_issuing_bank?: string;
            card_number?: string;
            card_holders_name?: string;
            expiration_date?: string;
            approval_code?: string;
            card_type?: string;
          };
        };
      }>;
    };
  }>;
}

export interface RoomPostingEntryBody {
  quantity: number;
  gross_amount: number;
  item: string;
  line_remarks?: string | null;
  payment_details?: object | null;
  or_no?: string | null;
  issuing_bank?: string | null;
  check_date: object | null;
  check_no?: string | null;
  gc_no?: string | null;
  card_network?: string | null;
  cc_issuing_bank?: string | null;
  card_no?: string | null;
  card_holders_name?: string | null;
  expiration_date?: string | null;
  approval_code?: string | null;
  card_type?: string | null;
  cl_payment_breakdown?: any[] | null;
}

export interface RoomPostingSubGroupFolioList {
  id: number;
  caption: string;
}

export interface RoomPostingInHouseGuestList {
  reference_id: string;
  room_code: string;
  room_types: string;
  room_number: string;
  guest_name: string;
  booking_id: string;
}

export interface RoomPostingTransferFolio {
  properties: [
    {
      property: {
        propertyID: string;
        sub_group_list: [
          {
            identifier_list: string;
            sub_group_id: number;
          },
        ];
      };
    },
  ];
}

export interface RoomPostingModifyServiceCharge {
  properties: [
    {
      property: {
        propertyID: string;
        trans_list: [
          {
            identifier_list: string;
            serv_charge_perc: number;
          },
        ];
      };
    },
  ];
}

export interface RoomPostingModifyItemRemarks {
  properties: [
    {
      property: {
        propertyID: string;
        trans_list: [
          {
            identifier_list: string;
            item_remarks: string;
          },
        ];
      };
    },
  ];
}

export interface RoomPostingCreditMemoIE {
  properties: [
    {
      property: {
        propertyID: string;
        cm_transaction: [
          {
            transaction_type: string; // USED || NEW
            transaction_identifier: string;
            cutoff_date: string;
            module_id: string | number;
            sub_group_id: string | number;
            remarks: string;
            guest_id: string | number;
            guest_name: string;
            credit_amount: number;
            cm_id: number;
          },
        ];
      };
    },
  ];
}

export interface RoomPostingCreditMemoVoucherIE {
  id: number;
  tgl_id: number;
  seriesId: number;
  transNo: string;
  referenceId: string;
  postDate: string;
  guestID: string;
  guestName: string;
  creditAmount: number;
  creditBal: number;
  creditUsed: number;
  staffName: string;
  bookingDetails: string;
}
export interface RoomPostingVoidItem {
  properties: [
    {
      property: {
        propertyID: string;
        item_list: [
          {
            identifier_list: string;
            void_reason: string;
          },
        ];
      };
    },
  ];
}

export interface RoomPostingRemoveDiscZero {
  properties: [
    {
      property: {
        propertyID: string;
        item_list: [
          {
            identifier_list: string;
          },
        ];
      };
    },
  ];
}
export interface RoomPostingRegularDiscounts {
  properties: [
    {
      property: {
        propertyID: string;
        trans_list: [
          {
            identifier_list: string;
            discount: number;
            is_percent: string;
            discount_remarks: string;
          },
        ];
      };
    },
  ];
}

export interface RoomPostingSpecialDiscounts {
  properties: [
    {
      property: {
        propertyID: string;
        trans_list: [
          {
            identifier_list: string;
            sd_list: object;
          },
        ];
      };
    },
  ];
}
export interface RoomPostingLineTransfer {
  properties: [
    {
      property: {
        propertyID: string;
        line_transfer_list: [
          {
            identifier_list: string;
            ref_id: string;
          },
        ];
      };
    },
  ];
}

export interface RoomPostingDataContext {
  selectedFolioUuid: string;
  selectedFolioStatus: string;
  selectedRoomStatus: string;
  setSelectedFolioUuid: React.Dispatch<React.SetStateAction<string>>;
  roomPostingLedgerList: RoomPostingLedgerList;
  setRoomPostingLedgerList: React.Dispatch<
    React.SetStateAction<RoomPostingLedgerList>
  >;
  selectedSubGroup: number;
  setSelectedSubGroup: React.Dispatch<React.SetStateAction<number>>;
  useProperty: string;
  ledgerRefetch: () => void;
  srcNav: any;
  transactionType: string;
  selectedLedgers: GridRowSelectionModel;
  setSelectedLedgers: React.Dispatch<
    React.SetStateAction<GridRowSelectionModel>
  >;
  clEditedRows: RoomPostingCLPaymentBreakdownEntry[];
  setCLEditedRows: React.Dispatch<
    React.SetStateAction<RoomPostingCLPaymentBreakdownEntry[]>
  >;
  isOpen: boolean;
}

export const RoomPostingLedgerInit: RoomPostingLedgerList = {
  status: 0,
  data: {
    folioUuid: '',
    folioNo: '',
    rateTotalAmount: 0,
    rateAmount: 0,
    dateCheckin: '',
    dateCheckout: '',
    profileID: '',
    totalBillAmount: '0.00',
    guestID: 0,
    guestName: '',
    isClHotel: 0,
    creditLimit: 0,
    totalPax: 0,
    roomNo: '',
    rowCount: 0,
    lockByUserShortName: '',
    netLock: 0,
    summary: {
      totalCharges: '0.00',
      totalCollection: '0.00',
      totalAdjustment: '0.00',
      totalPayables: '0.00',
    },
    balance: {
      defaultFolio: '0.00',
      folioA: '0.00',
      folioB: '0.00',
      folioC: '0.00',
      folioD: '0.00',
    },
    ledgerResult: [],
  },
  message: '',
  buildVersion: '',
};

export interface ICheckOutResponse {
  status: number;
  data: ICheckOutData;
  message: string;
  buildVersion: string;
}

export interface ICheckOutData {
  checkOutResponse: {
    code: number;
    response: string;
    checkout_type: string;
  };
}

export interface CheckOutTransactionBody {
  properties: [
    {
      property: {
        propertyID: string;
        checkouts: CheckOutBodyDetailed[];
      };
    },
  ];
}

export interface CheckOutBodyDetailed {
  checkout: {
    booking_reference_id: string;
    checkout_type: string;
    skip_validation_date: boolean;
    skip_validation_traces: boolean;
  };
}

export interface ITaxCodeResponse {
  status: number;
  data: ITaxCodeResponseData;
  message: string;
  buildVersion: string;
}

export interface ITaxCodeResponseData {
  dataResult: ITaxCodeResponseDataResult[];
}

export interface ITaxCodeResponseDataResult {
  id: number;
  code: string;
  description: string;
  taxType: string;
  vatType: string;
  taxRate: string;
  isActive: string;
}
